import * as React from 'react';
import { Header, Segment, Table as UITable } from 'semantic-ui-react';
export var IndicationRestrictionPayment = function (_a) {
    var detail = _a.detail, children = _a.children;
    return (<div data-testid={detail.type}>
		{children}
		{detail.records.map(function (record, i) { return (<Segment.Group key={i}>
				<Segment>
					<Header data-testid='record-header'>{"".concat(record.brand, " ").concat(record.supplement)}</Header>
				</Segment>
				<UITable padded sortable striped unstackable>
					{record.indicationTexts.map(function (text, j) { return (<UITable.Body data-testid='record' key={j}>
							<UITable.Row singleLine size='large'>
								<UITable.HeaderCell>{"".concat(j + 1, ". \u00FAhrada")}</UITable.HeaderCell>
							</UITable.Row>
							<UITable.Row>
								<UITable.Cell>{text !== null ? text : 'Přípravek byl ve SCAU, ale neměl podmínky úhrady'}</UITable.Cell>
							</UITable.Row>
						</UITable.Body>); })}
				</UITable>
			</Segment.Group>); })}
	</div>);
};
